<!-- 设备状态管理 -->
<!-- 首页//设备状态统计  -->
<template>
    <div class="box">
      <Title :text="maintain.AirConditioningStatus.Title[0]" :engText="maintain.AirConditioningStatus.Title[1]"></Title>
      <div class="content">
        <div class="a">
            <div class="b">
                <div class="left">
                    <div class="bgd"></div>
                    <div class="bgd2"></div>
                    <chart-block ref="echart1"></chart-block>
                </div>
                <div class="right">
                    <div>{{maintain.AirConditioningStatus.data1.text}}</div>
                    <div>
                        <span>在线：</span>
                        <span class="white">{{maintain.AirConditioningStatus.data1.onLine}}</span>
                    </div>
                    <div>
                        <span>离线：</span>
                        <span class="white">{{maintain.AirConditioningStatus.data1.outLine}}</span>
                    </div>
                </div>
            </div>
            <div class="b">
                <div class="left">
                    <div class="bgd"></div>
                    <div class="bgd2"></div>
                    <chart-block ref="echart2"></chart-block>
                </div>
                <div class="right">
                    <div>{{maintain.AirConditioningStatus.data2.text}}</div>
                    <div>
                        <span>在线：</span>
                        <span class="white">{{maintain.AirConditioningStatus.data2.onLine}}</span>
                    </div>
                    <div>
                        <span>离线：</span>
                        <span class="white">{{maintain.AirConditioningStatus.data2.outLine}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="a">
            <div class="b">
                <div class="left">
                    <div class="bgd"></div>
                    <div class="bgd2"></div>
                    <chart-block ref="echart3"></chart-block>
                </div>
                <div class="right">
                    <div>{{maintain.AirConditioningStatus.data3.text}}</div>
                    <div>
                        <span>在线：</span>
                        <span class="white">{{maintain.AirConditioningStatus.data3.onLine}}</span>
                    </div>
                    <div>
                        <span>离线：</span>
                        <span class="white">{{maintain.AirConditioningStatus.data3.outLine}}</span>
                    </div>
                </div>
            </div>
            <div class="b">
                <div class="left">
                    <div class="bgd"></div>
                    <div class="bgd2"></div>
                    <chart-block ref="echart4"></chart-block>
                </div>
                <div class="right">
                    <div>{{maintain.AirConditioningStatus.data4.text}}</div>
                    <div>
                        <span>在线：</span>
                        <span class="white">{{maintain.AirConditioningStatus.data4.onLine}}</span>
                    </div>
                    <div>
                        <span>离线：</span>
                        <span class="white">{{maintain.AirConditioningStatus.data4.outLine}}</span>
                    </div>
                </div>
            </div>
        </div>
          <!-- <div class="echarts-content">
            <chart-block ref="echart"></chart-block>
          </div> -->
      </div>
    </div>
  </template>
  
  <script>
  import Title from '../../components/title/index.vue';
  import { mapState,mapActions } from 'pinia' //引入映射函数
  import useStore from '@/store/index' //引入store
  export default {
    components: {
      Title,
    },
    computed:{
      ...mapState(useStore,['maintain']) 
    },
    mounted () {
        this.$refs.echart1.setOption(this.maintain.AirConditioningStatus.data1.option);
        this.$refs.echart2.setOption(this.maintain.AirConditioningStatus.data2.option);
        this.$refs.echart3.setOption(this.maintain.AirConditioningStatus.data3.option);
        this.$refs.echart4.setOption(this.maintain.AirConditioningStatus.data4.option);
    }
  }
  </script>
  
  <style scoped>
  .box{
     width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .content{
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .content .a{
    width: 100%;
    flex: 1;
    overflow: hidden;
    display: flex;
    
  }
  .a .b{
    flex: 1;
    height: 100%;
    display: flex;
  }
  .a .right{
    width: 61px;
    height: 100%;
    line-height: 20px;
    display: flex;
    font-size: 12px;
    flex-direction: column;
    justify-content: center;
  }
  .a .left{
    flex: 1;
    height: 100%;
    position: relative;

  }
  .a .left .bgd{
    width: 100%;
    height: 100%;
    position: absolute;
    /* background: red; */
    background: url('@/assets/img/c1.png') no-repeat;
    background-size: 95px 95px;
    background-position: center center;
    animation-name: identifier;
    animation-duration: 4s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

  }
  @keyframes identifier {
    from {transform: rotate(0deg)}
    to {transform: rotate(365deg)}
  }
  .a .left .bgd2{
    width: 100%;
    height: 100%;
    position: absolute;
    background: url('@/assets/img/d1.png') no-repeat;
    background-size: 64px 64px;
    background-position: center center;
  }
  .white{
    color: #fff;
  }

  </style>